import React, { useEffect } from "react";
import history from "../../../../history";
import { useCommonContext } from "../../../context/common-context";
import DefaultCard from "./default-card";

const setCookie = (name, value) =>
  (document.cookie = `${name}=${value}; path=/`);

const OrderDetailsCard = ({ category }) => {
  const { isGuest } = useCommonContext();
  const [showRed, setShowRed] = React.useState(false);

  const handleClick = React.useCallback(
    (href) => {
      if (category.link && category.link.defaultUrl) {
        if (isGuest) {
          setCookie(
            "ECommRedirectURL",
            encodeURIComponent(
              `${window.location.origin}${category.link.defaultUrl}`
            )
          );
        }
      }
      if (href) {
        window.location.href = href;
      }
    },
    [isGuest, category]
  );

  useEffect(() => {
    setShowRed(["Order Canceled"].includes(category.title));
  }, [category]);

  const activeTile = () => {
    return window.location.pathname === category.link.href ? "active" : "";
  };

  category.title =
    category.title.charAt(0).toUpperCase() + category.title.slice(1);

  return (
    <DefaultCard
      category={{
        ...category,
      }}
      showRed={showRed}
    />
  );
};

export default OrderDetailsCard;
